'use client';

import { UISerializableOrder, COMMON_UI_UTILS } from '@drift/common';
import useModal from 'src/components/Modals/hooks/useModal';
import { BigNum } from '@drift-labs/sdk';
import { EditOrderModalContent } from 'src/components/Modals/EditOrderModal/EditOrderModalContent';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';

export interface EditOrderModalProps {
	order: UISerializableOrder;
	newPrice?: BigNum;
}

const EditOrderModal = ({ order, newPrice }: EditOrderModalProps) => {
	const { hide } = useModal();
	const orderTypeLabel = COMMON_UI_UTILS.getOrderLabelFromOrderDetails(order);

	return (
		<ResponsiveModal.Container onClose={hide} dataTestId="edit-order-modal">
			<ResponsiveModal.Title closeButtonTestId="edit-order-modal-close">
				Edit {orderTypeLabel} Order
			</ResponsiveModal.Title>
			<EditOrderModalContent order={order} newPrice={newPrice} onClose={hide} />
		</ResponsiveModal.Container>
	);
};

export default EditOrderModal;
